
import React, { Component } from 'react';
import Table from "../../Utils/Grid";
import { BreakLine } from '../../Utils/tableOptions';
import CustomToolbar from '../../Utils/Toolbar/CustomToolbar';
import ToolbarSelect from '../../Utils/Toolbar/ToolbarSelect';
import {RenderCurrency} from "../../Utils/renderField/renderReadField";
import NumberFormat from "react-number-format";
import moment from "moment";

const SUPERUSER = 'superuser';

class CuentasPagadasIgss extends Component{
    componentWillUnmount() {
        this.props.resetStore();
    }
    componentWillMount() {
        this.props.listar()
    }

    render() {
        const {
            listar,
            setInitialDate,
            setFinalDate,
            payGroupIgss,
            openAccount,
            cancelOpenAccount,
        } = this.props;

        const {
            cargando,
            page,
            data,
            initial_date,
            final_date,
            saldo_total,
        } = this.props;

        console.log("OPEN ACCOUNTS: ", data);

        const options = [
            {value: 0, label: "Todas"},
            {value: 1, label: 'Cuenta'},
            {value: 2, label: 'Cirugía'},
            {value: 3, label: 'Diagnóstico'}
        ];

        return (
            <div className="content pt-3">
                <div className="m-auto row-fluid w-100">
                    <div className="table-decoration">


                    <div className="d-flex flex-row justify-content-around align-items-center">
                    <h4>HISTORIAL DE CUENTAS PAGADAS IGSS</h4>
                    {/*
                    <div className="top-title-toolbar">
                        <ToolbarSelect
                            titulo="CUENTAS PAGADAS IGSS"
                            buscar={this.props.changeFilter}
                            buscador={this.props.select_search}
                            options={options}
                            valueKey="value"
                            labelKey="label"
                            autofocus
                            ancho="w-75"
                        />
                    </div>
                    */}

                    <div className="d-flex flex-row justify-content-end align-items-center w-50">
                        {/*
                        <NumberFormat format="##/##/####" placeholder="DD/MM/YYYY" mask={['D', 'D', 'M', 'M', 'Y', 'Y', 'Y', 'Y']}
                            className="form-control w-20"
                            value={initial_date}
                            onValueChange={(values) => {
                                const dia = values.formattedValue.indexOf("D")
                                const mes = values.formattedValue.indexOf("M")
                                const anio = values.formattedValue.indexOf("Y")

                                if((dia + mes + anio) < 0){
                                    setInitialDate(values.formattedValue);
                                }
                            }}
                            autoFocus
                            onFocus={(e) => {
                                e.target.setSelectionRange(0,10);
                            }}
                        />

                        <NumberFormat format="##/##/####" placeholder="DD/MM/YYYY" mask={['D', 'D', 'M', 'M', 'Y', 'Y', 'Y', 'Y']}
                            className="form-control w-20 ml-2 mr-2"
                            value={final_date}
                            onValueChange={(values) => {
                                const dia = values.formattedValue.indexOf("D")
                                const mes = values.formattedValue.indexOf("M")
                                const anio = values.formattedValue.indexOf("Y")

                                if((dia + mes + anio) < 0){
                                    setFinalDate(values.formattedValue);
                                }
                            }}

                            onFocus={(e) => {
                                e.target.setSelectionRange(0,10);
                            }}
                        />
                        */}
                    <div className="top-title-toolbar mt-3">
                        <CustomToolbar
                            buscar={this.props.search}
                            buscador={this.props.buscador}
                        />
                    </div>
                    {/*
                    <div className='font-weight-bold ml-3 d-flex flex-row' style={{fontSize: 16}}>
                        Total:&nbsp;<RenderCurrency value={saldo_total} />
                    </div>
                    */}
                    </div>
                    </div>

                        <Table
                            onPageChange={listar}
                            data={data}
                            loading={cargando}
                            page={page}
                        >
                            <TableHeaderColumn
                                tdStyle={BreakLine}
                                thStyle={BreakLine}
                                dataField="correlative"
                                dataSort
                                >Factura</TableHeaderColumn>

                            <TableHeaderColumn
                                tdStyle={BreakLine}
                                thStyle={BreakLine}
                                dataField="made"
                                dataSort
                            >Fecha</TableHeaderColumn>

                            <TableHeaderColumn
                                tdStyle={BreakLine}
                                thStyle={BreakLine}
                                dataField="igss_paid_accounts"
                                dataFormat={(cell)=>{
                                    return (
                                        <React.Fragment>
                                            <span>{cell.split(",").map((account, index) => {
                                                return (
                                                    <React.Fragment>
                                                        <span
                                                            style={{ color:"blue", textDecoration: "underline", cursor: "pointer" }}
                                                            onClick={()=>openAccount(account)}
                                                            key={index}
                                                        >{account}</span>
                                                        &nbsp;&nbsp;
                                                    </React.Fragment>
                                                );
                                            })}</span>
                                        </React.Fragment>
                                    );
                                }}
                                dataSort
                            >Cuentas cerradas</TableHeaderColumn>

                            <TableHeaderColumn
                                dataField="id"
                                isKey={true}
                                dataAlign="center"

                                dataFormat={(cell)=>{
                                    return(
                                        <React.Fragment>
                                            {this.props.usuario.role_name === SUPERUSER &&
                                                <span  className="cancel-account" onClick={()=>cancelOpenAccount(cell)}>Anular</span>
                                            }
                                        </React.Fragment>
                                    );
                                }}
                                >Acciones</TableHeaderColumn>
                        </Table>
                    </div>
                </div>
            </div>
        )
    }
}

export default CuentasPagadasIgss;
